module.exports = __webpack_public_path__ + "media/images/gallery/stars/cygnus/sadr_vis-cd5459d6d2b6dc896b756ef4138378f5.jpg";